import classNames from 'classnames';
import React from 'react';
import {
    BodyMedium,
    ButtonOutlineLarge,
    ButtonPrimaryLarge,
    H3,
    SectionWrapperInner,
    SectionWrapperOuter,
} from '@react/styledComponents';

import { useScreenMinMd, useScreenSmDown } from '@hooks/useResponsive';

const MembershipHoldPage = () => {
    const isScreenMinMd = useScreenMinMd();
    const isScreenSmDown = useScreenSmDown();

    return (
        <SectionWrapperOuter>
            <SectionWrapperInner>
                <div className="container">
                    <div className="gap-8 grid-cols-8 md:grid">
                        <div className="col-span-5">
                            <H3>Sorry for the interruption</H3>

                            <BodyMedium className="mt-0.75rem">
                                Thank you for your interest in a membership with ICSC!
                            </BodyMedium>

                            <BodyMedium className="mt-1rem">
                                We are currently reviewing your application. An ICSC representative will be contacting
                                you within the next 24 hours to complete your membership.
                            </BodyMedium>

                            <BodyMedium className="mt-1rem">
                                In the meantime, should you have any questions or need additional information, please do
                                not hesitate to contact Membership Services at{' '}
                                <a className="text-link" href="tel:+16467283500">
                                    +1 646 728-3500
                                </a>{' '}
                                or{' '}
                                <a className="text-link" href="mailto:membership@icsc.com">
                                    membership@icsc.com
                                </a>
                                .
                            </BodyMedium>

                            <div
                                className={classNames({
                                    'flex mt-2.5rem': isScreenMinMd,
                                    'mt-1.5rem': isScreenSmDown,
                                })}
                            >
                                <div>
                                    <ButtonPrimaryLarge as="a" href="/">
                                        Back to Homepage
                                    </ButtonPrimaryLarge>
                                </div>

                                <div
                                    className={classNames({
                                        'ml-1.5rem': isScreenMinMd,
                                        'mt-1rem': isScreenSmDown,
                                    })}
                                >
                                    <ButtonOutlineLarge as="a" href="/attend-and-learn/events">
                                        ICSC Events
                                    </ButtonOutlineLarge>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SectionWrapperInner>
        </SectionWrapperOuter>
    );
};

export default MembershipHoldPage;
